import { Component, Element, Prop, Listen } from "@stencil/core";

@Component({
    tag: "ux-iws-e-catalog-form-handler",
    shadow: false,
})
export class UxIwsECatalogFormHandler {
    @Element() host: HTMLUxIwsECatalogFormHandlerElement;

    /** The scope of the component. */
    @Prop() scope: string;
    /** Name which is passed down as the hidden input name */
    @Prop() name: string = "";

    private form: HTMLFormElement;
    private submitButton: HTMLButtonElement;

    @Listen("uxCheckboxChange", { target: "window" })
    setFormElements(event: CustomEvent) {
        const checkbox = event.target as HTMLElement;
        const parentTable = checkbox.closest("ux-table");
        if (!parentTable) {
            return;
        }

        let value = event.detail.value;

        // fix for broken mobile table checkbox
        const checkboxInputs = checkbox.querySelectorAll(".ux-checkbox__input");
        if (checkboxInputs && checkboxInputs.length > 1) {
            const innerInput = checkbox.querySelector(
                ".ux-checkbox__slot-container .ux-checkbox__input"
            );
            if (innerInput !== null && innerInput !== undefined) {
                value = innerInput.getAttribute("value");
            }
        }

        this.updateHiddenFormField(event.detail.checked, value);
    }

    componentDidLoad() {
        this.form = document.getElementById(
            `${this.scope}-form`
        ) as HTMLFormElement;

        if (this.form === null) return;

        this.submitButton = document.querySelector(
            `ux-button[type="submit"][form="${this.scope}-form"]`
        );
        this.submitButton.disabled = true;

        if (this.submitButton !== null) {
            this.submitButton.addEventListener(
                "click",
                this.handleSubmit.bind(this)
            );
        }
    }

    private updateHiddenFormField(checked: boolean, value: string) {
        const existingHiddenField = this.form.querySelector(
            `input[type="hidden"][value="${value}"]`
        );

        if (checked) {
            if (existingHiddenField === null) {
                const hiddenField = document.createElement("input");
                hiddenField.type = "hidden";
                hiddenField.name = this.name;
                hiddenField.value = value;
                this.form.appendChild(hiddenField);
            }
        } else {
            if (existingHiddenField !== null) {
                this.form.removeChild(existingHiddenField);
            }
        }

        const hiddenInputs = this.form.querySelectorAll('input[type="hidden"]');
        this.submitButton.disabled = hiddenInputs.length === 0;
    }

    private handleSubmit(event: Event) {
        event.preventDefault();
        this.form.submit();
    }
}
